import { render, staticRenderFns } from "./select_infinite.vue?vue&type=template&id=5611f0da&"
import script from "./select_infinite.vue?vue&type=script&lang=js&"
export * from "./select_infinite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports